import { crudGetList } from 'react-admin';
import { useMutation, useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import { history } from './../App';
import { deleteRole, getAllRoles } from '~/api/roles';

export const useAllRoles = () => {
  return useQuery(['roles'], () => getAllRoles());
};

export const useDeleteRole = () => {
  const dispatch = useDispatch();

  return useMutation(deleteRole, {
    onSuccess() {
      dispatch(crudGetList('roles', { page: 1, perPage: 25 }, { field: 'id', order: 'DESC' }, {}));
      history.push('/roles?page=1');
    },
  });
};
